import React from 'react';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../utils/languageUtils';

interface TimezoneOption {
    label: string;
    value: string;
}

interface TimezoneFilterItemProps {
    /** 展示文案，由调用方指定 */
    label: string;
    value?: string;
    onChange?: (value: string | undefined) => void;
    /** 可选时区列表，由调用方传入（组件本身不绑定任何业务时区数据） */
    options: TimezoneOption[];
    placeholder?: string;
    allowClear?: boolean;
    /** 外层容器（label+输入框）className */
    className?: string;
    spanClassName?: string;
    /** Select 自身的 className，默认 'w-full' */
    selectClassName?: string;
    /** Select 尺寸，默认 'middle' */
    size?: SelectProps['size'];
}

/**
 * 通用时区筛选下拉框：不依赖任何业务域数据，label/options 均由调用方传入，样式沿用项目通用的筛选项布局。
 */
export const TimezoneFilterItem: React.FC<TimezoneFilterItemProps> = ({
    label,
    value,
    onChange,
    options,
    placeholder,
    allowClear = true,
    className,
    spanClassName,
    selectClassName = 'w-full',
    size = 'middle'
}) => {
    const containerClassName = useFilterContainerClassName(className);
    const labelClassName = useFilterLabelClassName(spanClassName);
    const inputContainerClassName = useFilterInputContainerClassName();

    return (
        <div className={containerClassName}>
            <span className={labelClassName}>{label}</span>
            <div className={inputContainerClassName}>
                <Select
                    value={value}
                    onChange={(selected: string) => onChange?.(selected || undefined)}
                    options={options}
                    allowClear={allowClear}
                    suffixIcon={<DownOutlined />}
                    placeholder={placeholder}
                    className={selectClassName}
                    size={size}
                />
            </div>
        </div>
    );
};
